module.exports = __webpack_public_path__ + "img/sphere09-graph.ac1191db.png";